export const statusColorCode = {
  //---------campus---------------------------
  14: "#00905f", //joined equal to (30)
  12: "#00bf7e", //offered (equal to 28)
  3: "#0202d4", //R1 Shortlisted (equal to 18)
  7: "#2a2a92", //R2 Shortlisted (equal to 22)
  10: "#000088", //L3 Shortlisted (equal to 26)
  1: "#ff0000",
  2: "#ffb2b2", //R1 Rejected : (change 16)
  5: "#b80000", //R2 Rejected (equal to 20)
  8: "#7d0000", //L3 Rejected (equal to 25)
  6: "#ffba00", //R2 Longlisted (equal to 21)
  9: "#b88600", // L3 Longlisted
  4: "#000330", //R2 Not Rated (equal to 17)
  11: "#7a006a", //candidate dropout (equal to 27)
  13: "#aa0294", // not joined (equal to 29)
  0: "#000000", // not rated
  //----------------lateral-------------
  30: "#00905f", //joined
  28: "#00bf7e", //offered
  22: "#2a2a92", //L1 Shortlisted
  24: "#00a0ff", //L2 Shortlisted
  26: "#000088", //L3 Shortlisted
  18: "#0202d4", //HR Shortlisted
  15: "#ff0000", //Filter Reject
  16: "#ffb2b2", //HR Rejected (same as R1 Rejected)

  20: "#b80000", //L1 Rejected
  23: "#ea4c14", //L2 Rejected
  25: "#7d0000", //L3 Rejected

  21: "#ffba00", //L1 Can Consider
  17: "#000330", // HR Can Consider
  19: "#CCD5CC", //L1 Not Rated
  27: "#7a006a", //candidate dropout
  29: "#aa0294", // not joined
};

// 9,19, 23,24
